"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _chunkTDBT7GQPjs = require("./chunk-TDBT7GQP.js");
var _chunkV767VWABjs = require("./chunk-V767VWAB.js");
var _chunkYULSKELGjs = require("./chunk-YULSKELG.js");
var _chunkL6B4ALZ3js = require("./chunk-L6B4ALZ3.js");
// src/utils/validators.ts
var _ciamsdk = require("@inner-source/ciam-sdk");
function validateConfig(baseClass) {
    return /*#__PURE__*/ function(baseClass) {
        _inherits(_class, baseClass);
        var _super = _create_super(_class);
        function _class() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            _class_call_check(this, _class);
            var _args = _sliced_to_array(args, 1), _args_ = _args[0], stateParams = _args_.stateParams, redirectUrl = _args_.redirectUrl, clientSecret = _args_.clientSecret, clientId = _args_.clientId, environment = _args_.environment;
            _chunkTDBT7GQPjs.StringValidator.validateStringValue(stateParams.relyingParty, "relying-party");
            _chunkTDBT7GQPjs.StringValidator.validateStringValue(clientSecret, "clientSecret");
            _chunkTDBT7GQPjs.StringValidator.validateStringValue(clientId, "clientId");
            _chunkTDBT7GQPjs.StringValidator.validateStringValue(redirectUrl, "redirectUrl");
            _chunkTDBT7GQPjs.StringValidator.validateUrl(redirectUrl);
            validateEnvironment(environment);
            return _super.call.apply(_super, [
                this
            ].concat(_to_consumable_array(args)));
        }
        return _class;
    }(baseClass);
}
function validateNonce(target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
        throw new Error(_chunkYULSKELGjs.errorMessages.NOT_A_FUNCTION_ERROR);
    }
    var originalMethod = descriptor.value;
    descriptor.value = function validateNonceMethod(data) {
        if (typeof data.id_token !== "string") {
            throw new Error(_chunkYULSKELGjs.errorMessages.INVALID_ID_TOKEN);
        }
        var decodedNonce = _ciamsdk.decodeJwt.call(void 0, data.id_token);
        if (typeof decodedNonce.payload !== "object" || decodedNonce.payload === null || typeof decodedNonce.payload.nonce !== "string") {
            throw new Error(_chunkYULSKELGjs.errorMessages.INVALID_NONCE_JWT_PAYLOAD);
        }
        var nonce = decodedNonce.payload.nonce;
        var instance = this;
        _chunkTDBT7GQPjs.StringValidator.validateStringValue(nonce, "nonce");
        if (nonce !== instance.getNonce()) {
            throw new (0, _chunkV767VWABjs.NonceError)(_chunkYULSKELGjs.errorMessages.INVALID_NONCE_DOES_NOT_MATCH);
        }
        return originalMethod.call(this, data);
    };
}
function validateResponseKeys(target, propertyKey, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function validateResponse(data) {
        if (!data.access_token) {
            throw new (0, _chunkV767VWABjs.InvalidHttpTokenResponseError)(_chunkYULSKELGjs.errorMessages.MISSING_ACCESS_TOKEN_RESPONSE_KEY);
        }
        if (!data.expires_in) {
            throw new (0, _chunkV767VWABjs.InvalidHttpTokenResponseError)(_chunkYULSKELGjs.errorMessages.MISSING_EXPIRES_IN_RESPONSE_KEY);
        }
        if (!data.refresh_token) {
            throw new (0, _chunkV767VWABjs.InvalidHttpTokenResponseError)(_chunkYULSKELGjs.errorMessages.MISSING_REFRESH_TOKEN_RESPONSE_KEY);
        }
        if (!data.token_type) {
            throw new (0, _chunkV767VWABjs.InvalidHttpTokenResponseError)(_chunkYULSKELGjs.errorMessages.MISSING_TOKEN_TYPE_RESPONSE_KEY);
        }
        return originalMethod.call(this, data);
    };
}
function validateResponseKeysWithoutRT(target, propertyKey, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function validateResponse(data) {
        if (!data.access_token) {
            throw new (0, _chunkV767VWABjs.InvalidHttpTokenResponseError)(_chunkYULSKELGjs.errorMessages.MISSING_ACCESS_TOKEN_RESPONSE_KEY);
        }
        if (!data.expires_in) {
            throw new (0, _chunkV767VWABjs.InvalidHttpTokenResponseError)(_chunkYULSKELGjs.errorMessages.MISSING_EXPIRES_IN_RESPONSE_KEY);
        }
        if (!data.token_type) {
            throw new (0, _chunkV767VWABjs.InvalidHttpTokenResponseError)(_chunkYULSKELGjs.errorMessages.MISSING_TOKEN_TYPE_RESPONSE_KEY);
        }
        return originalMethod.call(this, data);
    };
}
var validParams = [
    "state",
    "code",
    "lastOp",
    "casl",
    "utm[utm_source]",
    "utm[utm_medium]",
    "utm[utm_campaign]",
    "utm[utm_term]",
    "utm[utm_content]",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content"
];
function validateURLSearchParams(target, propertyKey, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function validatedMethod(search) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = search.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (!validParams.includes(key)) {
                    throw new (0, _chunkV767VWABjs.InvalidURLSearchParamsError)("[".concat(key, "]: invalid Key."));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!search.get("code")) {
            throw new (0, _chunkV767VWABjs.MissingSearchCodeParamError)(_chunkYULSKELGjs.errorMessages.MISSING_CODE_PARAM_ERROR);
        } else if (!search.get("state")) {
            throw new (0, _chunkV767VWABjs.MissingSearchStateParamError)(_chunkYULSKELGjs.errorMessages.MISSING_STATE_PARAM_ERROR);
        }
        return originalMethod.call(this, search);
    };
}
function validateCsrf(target, propertyKey, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function validatedMethod(search) {
        if (search.get("state")) {
            var state = search.get("state");
            try {
                state = decodeURIComponent(state);
                state = state.replace(/\s/g, "+");
            } catch (e) {}
            var csrf = _ciamsdk.decodeState.call(void 0, state).csrf;
            var instance = this;
            _chunkTDBT7GQPjs.StringValidator.validateStringValue(csrf, "csrf");
            if (csrf !== instance.getCsrf()) {
                throw new (0, _chunkV767VWABjs.CsrfError)(_chunkYULSKELGjs.errorMessages.INVALID_CSRF_DOES_NOT_MATCH);
            }
        }
        return originalMethod.call(this, search);
    };
}
function validateAuthCodeVerifierKey(target, propertyKey, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function validate() {
        var codeVerifier = originalMethod.call(this);
        if (!codeVerifier) {
            throw new (0, _chunkV767VWABjs.AuthCodeNotFoundError)(_chunkYULSKELGjs.errorMessages.AUTH_CODE_VERIFIER_KEY_NOT_FOUND);
        }
        return codeVerifier;
    };
}
function validateResponseStatus(target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
        throw new Error(_chunkYULSKELGjs.errorMessages.NOT_A_FUNCTION_ERROR);
    }
    var originalMethod = descriptor.value;
    descriptor.value = function validate(HTTPRawResponse) {
        if (HTTPRawResponse.status >= 100 && HTTPRawResponse.status < 200) {
            throw new (0, _chunkV767VWABjs.StatusCode1xxError)(_chunkYULSKELGjs.errorMessages.INVALID_1XX_ERRORS);
        } else if (HTTPRawResponse.status >= 300 && HTTPRawResponse.status < 400) {
            throw new (0, _chunkV767VWABjs.StatusCode3xxError)(_chunkYULSKELGjs.errorMessages.INVALID_3XX_ERRORS);
        } else if (HTTPRawResponse.status >= 400 && HTTPRawResponse.status < 500) {
            throw new (0, _chunkV767VWABjs.StatusCode4xxError)(_chunkYULSKELGjs.errorMessages.INVALID_4XX_ERRORS);
        } else if (HTTPRawResponse.status >= 500 && HTTPRawResponse.status < 600) {
            throw new (0, _chunkV767VWABjs.StatusCode5xxError)(_chunkYULSKELGjs.errorMessages.INVALID_5XX_ERRORS);
        }
        return originalMethod.call(this, HTTPRawResponse);
    };
}
function validateRequest(target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
        throw new Error(_chunkYULSKELGjs.errorMessages.NOT_A_FUNCTION_ERROR);
    }
    var originalMethod = descriptor.value;
    descriptor.value = function validate(requestUrl, data) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        _chunkTDBT7GQPjs.StringValidator.validateStringValue(requestUrl, "requestUrl");
        _chunkTDBT7GQPjs.StringValidator.validateUrl(requestUrl);
        return originalMethod.call(this, requestUrl, data, options);
    };
}
function validateEnvironment(environment) {
    if (!Object.values(_chunkL6B4ALZ3js.Environment).includes(environment)) {
        throw new (0, _chunkV767VWABjs.EnvironmentNotGivenError)(_chunkYULSKELGjs.errorMessages.ENVIRONMENT_NOT_PRESENT);
    }
}
exports.validateConfig = validateConfig;
exports.validateNonce = validateNonce;
exports.validateResponseKeys = validateResponseKeys;
exports.validateResponseKeysWithoutRT = validateResponseKeysWithoutRT;
exports.validateURLSearchParams = validateURLSearchParams;
exports.validateCsrf = validateCsrf;
exports.validateAuthCodeVerifierKey = validateAuthCodeVerifierKey;
exports.validateResponseStatus = validateResponseStatus;
exports.validateRequest = validateRequest;
exports.validateEnvironment = validateEnvironment;
